import index from './index.vue'
export default index


// WEBPACK FOOTER //
// ./src/components/global/codes2/index.js